import React, { useEffect, useState } from "react";
import { t as T } from "i18next";
import api from "../../lib/api";
import PostCard from "./PostCard";

// v220: felles reaksjoner/kommentarer for album-filer (tråd = innlegget filen kom fra, eller skjult tråd).
export default function PostThreadPanel({ postId, fromPost }) {
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    setPost(null);
    setErr(false);
    api.get(`/profile-posts/${postId}/thread`).then((r) => setPost(r.data)).catch(() => setErr(true));
  }, [postId]);
  if (err) return <p className="p-3 text-xs text-[var(--cream-faint)]" data-testid="thread-panel-error">{T("ui.comments_unavailable")}</p>;
  if (!post) return <p className="p-3 text-xs text-[var(--cream-faint)]">…</p>;
  return (
    <div className="overflow-y-auto p-2" data-testid="thread-panel">
      {fromPost && (
        <div className="font-meta text-[10px] uppercase tracking-wider text-[var(--magenta)] px-1 mb-1" data-testid="thread-panel-from-post">
          {T("ui.from_post")}
        </div>
      )}
      <PostCard post={post} hideMedia threadMode={!fromPost} />
    </div>
  );
}
